import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

/**
 * Component that automatically sets canonical URL for all pages
 * Ensures search engines always use the .in domain version
 */
function CanonicalTag() {
  const location = useLocation();
  
  // Base URL - always use the .in domain
  const baseUrl = 'https://lunarelectric.in';
  
  // Get the current pathname and build the full canonical URL
  const canonicalUrl = `${baseUrl}${location.pathname}${location.search}`;
  
  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}

export default CanonicalTag;

